(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[837],{

/***/ 4122:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lets-explore",
      function () {
        return __webpack_require__(3770);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ StyledTextBlock; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2125);
/* harmony import */ var _layout_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6797);
/* harmony import */ var _styles_textLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(308);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n\n  > * {\n    margin: 0 0 1rem 0;\n    max-width: 45rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1 {\n    ",
        "\n    font-size: ",
        ";\n  }\n  \n  h2 {\n    ",
        "\n    font-size: ",
        ";\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n\n  h3 {\n    ",
        "\n    font-size: ",
        ";\n  }\n\n  a {\n    color: inherit;\n    text-decoration-color: ",
        ";\n    text-underline-offset: 3px;\n    text-decoration-thickness: 1px;\n  }\n\n  > a,\n  p a:only-child {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function TextBlock(param) {
    var _color = param.color, color = _color === void 0 ? "grey2" : _color, textStyle = param.textStyle, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Container__WEBPACK_IMPORTED_MODULE_2__/* .ShiftAlign */ .Ow, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTextBlock, {
                $color: color,
                $size: textStyle,
                dangerouslySetInnerHTML: {
                    __html: children
                }
            })
        })
    });
}
var StyledTextBlock = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed2c3774-0"
})(_templateObject(), function(p) {
    return p.theme.getColor(p.$color);
}, function(p) {
    return p.$size === "large" ? p.theme.typo.sizes.large : p.theme.typo.sizes.medium;
}, function(p) {
    return p.theme.typo.neueHaasBold;
}, function(p) {
    return p.theme.typo.sizes.medium;
}, function(p) {
    return p.theme.typo.neueHaasBold;
}, function(p) {
    return p.theme.typo.sizes.normal;
}, function(p) {
    return p.theme.typo.neueHaasBold;
}, function(p) {
    return p.theme.typo.sizes.normal;
}, function(p) {
    return p.theme.colors.highlight;
}, _styles_textLink__WEBPACK_IMPORTED_MODULE_3__/* .soloTextLink */ .RY);
/* harmony default export */ __webpack_exports__["Z"] = (TextBlock);


/***/ }),

/***/ 8375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2125);
/* harmony import */ var _layout_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6797);
/* harmony import */ var _CmsTextBlock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1864);
/* harmony import */ var _ImagesBlock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9948);
/* harmony import */ var _Video__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1778);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(570);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5741);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  --para-margin: 1rem;\n  --button-margin: 3rem;\n  --media-margin: 4rem;\n\n  .hod-text-block {\n    &:not( :first-child ) {\n      margin-top: var( --para-margin );\n    }\n    \n    &:not( :last-child ) {\n      margin-bottom: var( --para-margin );\n    }\n  }\n  \n  .hod-text-block--large {\n    &:not( :first-child ) {\n      margin-top: var( --button-margin );\n    }\n    \n    &:not( :last-child ) {\n      margin-bottom: var( --button-margin );\n    }\n  }\n  \n  .hod-button-block {\n    &:not( :first-child ) {\n      margin-top: var( --button-margin );\n    }\n    \n    &:not( :last-child ) {\n      margin-bottom: var( --button-margin );\n    }\n  }\n\n  .hod-images-block,\n  .hod-video-block {\n    &:not( :first-child ) {\n      margin-top: var( --media-margin );\n    }\n    \n    &:not( :last-child ) {\n      margin-bottom: var( --media-margin );\n    }\n  }\n\n  .hod-video-block {\n    > div {\n      position: relative;\n      overflow: hidden;\n      width: 100%;\n      padding-bottom: 56.25%;\n\n      > iframe {\n        left: 0;\n        top: 0;\n        height: 100%;\n        width: 100%;\n        position: absolute;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  margin: var( --grid-parent-gutter );\n\n  > * {\n    box-sizing: border-box;\n    margin: var( --grid-child-gutter );\n    flex: 1 0 calc( 33.333% - 2rem );\n    min-width: 200px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








function ContentBuilder(param) {
    var content = param.content, _light = param.light, light = _light === void 0 ? false : _light;
    var color = light ? "grey9" : "grey2";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContentStack, {
        children: content.map(function(contentBlock) {
            if (contentBlock.typeHandle === "text") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "hod-text-block hod-text-block--".concat(contentBlock.style),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_CmsTextBlock__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        color: color,
                        textStyle: contentBlock.style || "normal",
                        children: contentBlock.text
                    })
                }, contentBlock.id);
            }
            if (contentBlock.typeHandle === "images") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    className: "hod-images-block",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImagesBlock, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ImagesBlock__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            images: contentBlock.images,
                            layout: "auto"
                        })
                    })
                }, contentBlock.id);
            }
            if (contentBlock.typeHandle === "video") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    className: "hod-video-block",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Video__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            contentItem: contentBlock
                        })
                    })
                }, contentBlock.id);
            }
            if (contentBlock.typeHandle === "button") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    className: "hod-button-block",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Container__WEBPACK_IMPORTED_MODULE_2__/* .ShiftAlign */ .Ow, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            $inline: true,
                            $color: color,
                            $textColor: light ? "grey2" : "grey9",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                href: contentBlock.buttonLink,
                                children: contentBlock.buttonText
                            })
                        })
                    })
                }, contentBlock.id);
            }
            return null;
        })
    });
}
var StyledContentStack = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-926f21a5-0"
})(_templateObject());
var StyledImagesBlock = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-926f21a5-1"
})(_templateObject1());
/* harmony default export */ __webpack_exports__["Z"] = (ContentBuilder);


/***/ }),

/***/ 6753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LetsDiscusCTABlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(6797);
// EXTERNAL MODULE: ./components/layout/Stack.tsx
var Stack = __webpack_require__(4970);
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(570);
// EXTERNAL MODULE: ./styles/textLink.ts
var textLink = __webpack_require__(308);
;// CONCATENATED MODULE: ./components/CTABlock.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 55.03%;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: ",
        ";\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: linear-gradient(\n      180deg, \n      rgba(144, 62, 255, 0) 4.25%, \n      rgba(144, 62, 255, 0.4) 20.66%, \n      rgba(144, 62, 255, 0.8) 34.72%, \n      #903EFF 53.47%, \n      rgba(144, 62, 255, 0.8) 71.18%, \n      rgba(144, 62, 255, 0.4) 87.85%, \n      rgba(144, 62, 255, 0) 100%\n    );\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  color: ",
        ";\n\n  > * {\n    position: relative;\n    z-index: 1;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    ",
        "\n    font-size: ",
        ";\n  }\n\n  ",
        " {\n    display: flex;\n    justify-content: center;\n\n    button,\n    a {\n      ",
        ";\n      font-size: ",
        ";\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  }\n  \n  > div > a {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






function CTABlock(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCTABlockWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCTABlock, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    $top: 10,
                    $between: 2,
                    $bottom: 10,
                    children: children
                })
            })
        })
    });
}
var StyledCTABlockWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a575ee6-0"
})(_templateObject(), function(p) {
    return p.theme.colors.grey9;
});
var StyledCTABlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a575ee6-1"
})(_templateObject1(), function(p) {
    return p.theme.colors.grey9;
}, function(p) {
    return p.theme.typo.neueHaasBold;
}, function(p) {
    return p.theme.typo.sizes.bigCTA;
}, Button/* default */.Z, function(p) {
    return p.theme.typo.neueHaasBold;
}, function(p) {
    return p.theme.typo.sizes.large;
}, function(p) {
    return p.theme.colors.highlight;
}, function(p) {
    return p.theme.colors.grey9;
}, textLink/* soloTextLink */.RY);
/* harmony default export */ var components_CTABlock = (CTABlock);

// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(5741);
;// CONCATENATED MODULE: ./components/LetsDiscusCTABlock.tsx





function LetsDiscusCTABlock() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_CTABlock, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    description: "Has this project made you think?",
                    defaultMessage: "Has this project made you think?",
                    id: "Q6KiQZ"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                $rounded: true,
                $color: "grey9",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                    href: "/lets-discuss",
                    children: "Let\u2019s discuss"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                href: "/lets-explore",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    description: "More information",
                    defaultMessage: "More information",
                    id: "aGuUOT"
                })
            })
        ]
    });
}
/* harmony default export */ var components_LetsDiscusCTABlock = (LetsDiscusCTABlock);


/***/ }),

/***/ 5159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ activities_Activities; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(5741);
// EXTERNAL MODULE: ./components/Image.tsx
var Image = __webpack_require__(7753);
// EXTERNAL MODULE: ./components/activities/Activity.tsx + 7 modules
var Activity = __webpack_require__(3194);
;// CONCATENATED MODULE: ./components/activities/ActivityTile.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n\n  > a {\n    position: relative;\n    display: flex;\n    box-sizing: border-box;\n    width: 100%;\n    max-width: 100%;\n    aspect-ratio: 1;\n    /* min-height: calc( 8.678em - ( ",
        " * 2 ) ); */\n    flex-direction: column;\n    padding: ",
        ";\n    color: ",
        ";\n    text-decoration: none;\n    font-size: ",
        ";\n\n    > h2 {\n      position: relative;\n      margin: 0;\n      ",
        ";\n      font-size: inherit;\n    }\n\n    > p {\n      position: relative;\n      margin: 0 0 2rem 0;\n      font-size: inherit;\n    }\n\n    @media ( max-width: 500px ) {\n      font-size: ",
        ";\n    }\n  }\n\n  ",
        " {\n    margin-top: auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  img {\n    filter: grayscale( 1 );\n  }\n  \n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background: ",
        ";\n    opacity: 0.9;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





function ActivityTile(param) {
    var activity = param.activity;
    var ref;
    var image = activity.activityImage[0] || null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledActivityTile, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.ZP, {
            href: "/lets-make/".concat(activity.slug),
            children: [
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBgImage, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: image.url,
                        alt: "",
                        layout: "fill",
                        objectFit: "cover",
                        objectPosition: "".concat(image.focalPoint[0] * 100, "% ").concat(image.focalPoint[1] * 100, "%")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: activity.title
                }),
                activity.subHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: activity.subHeading
                }),
                ((ref = activity.activityType) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Activity/* StyledActivityTypes */.R, {
                    children: activity.activityType.map(function(activityType) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: activityType.title
                        }, activityType.id);
                    })
                })
            ]
        })
    });
}
var StyledActivityTile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f1b3382-0"
})(_templateObject(), function(p) {
    return p.theme.typo.sizes.large;
}, function(p) {
    return p.theme.typo.sizes.large;
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.typo.sizes.large;
}, function(p) {
    return p.theme.typo.neueHaasBold;
}, function(p) {
    return p.theme.typo.sizes.medium;
}, Activity/* StyledActivityTypes */.R);
var StyledBgImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f1b3382-1"
})(_templateObject1(), function(p) {
    return p.theme.colors.grey4;
});
/* harmony default export */ var activities_ActivityTile = (ActivityTile);

;// CONCATENATED MODULE: ./components/activities/Activities.tsx

function Activities_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  margin: var( --grid-parent-gutter );\n\n  > * {\n    margin: var( --grid-child-gutter );\n  }\n\n  @media ( min-width: 600px ) {\n    grid-template-columns: repeat( 2, 1fr );\n  }\n  \n  @media ( min-width: 1000px ) {\n    grid-template-columns: repeat( 3, 1fr );\n  }\n"
    ]);
    Activities_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function Activities(param) {
    var activities = param.activities;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledActivities, {
        children: activities.map(function(activity) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(activities_ActivityTile, {
                activity: activity
            }, activity.id);
        })
    });
}
var StyledActivities = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-335513c7-0"
})(Activities_templateObject());
/* harmony default export */ var activities_Activities = (Activities);


/***/ }),

/***/ 3362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function PlusIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12 1V23",
                stroke: "#0F0F0F",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M23 12H1",
                stroke: "#0F0F0F",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PlusIcon);


/***/ }),

/***/ 8834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ responses_ResponseItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(5741);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
;// CONCATENATED MODULE: ./components/icons/VideoIcon.tsx

function VideoIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "40",
        viewBox: "0 0 24 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M22.8332 20L1.63982 1.59541L1.63982 38.4047L22.8332 20Z",
            stroke: "white",
            strokeWidth: "2",
            strokeLinejoin: "round"
        })
    });
}
/* harmony default export */ var icons_VideoIcon = (VideoIcon);

;// CONCATENATED MODULE: ./components/icons/AudioIcon.tsx

function AudioIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "35",
        height: "34",
        viewBox: "0 0 35 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.615 1V33",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.7968 5.36359V31.5454",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.97864 11.1818V25.7273",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.61499 17V19.9091",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.4332 5.36359V31.5454",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.2513 11.1818V25.7273",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.615 17V19.9091",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
/* harmony default export */ var icons_AudioIcon = (AudioIcon);

;// CONCATENATED MODULE: ./components/icons/TextIcon.tsx

function TextIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "34",
        height: "30",
        viewBox: "0 0 34 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.6665 28.3333H32.3332",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.6665 1.66663H28.3332",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.6665 8.33331H22.9998",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.6665 14.9999H32.3332",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.6665 21.6666H26.9998",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
/* harmony default export */ var icons_TextIcon = (TextIcon);

;// CONCATENATED MODULE: ./components/responses/ResponseIcon.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    > * {\n      transform: translateX( 5px );\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  left: 50%;\n  width: 64px;\n  transform: translate( -50%, -50% );\n  height: 64px;\n  border-radius: 100%;\n  background: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





function ResponseIcon(param) {
    var type = param.type;
    if (type === "photo") {
        return null;
    }
    var icon = function() {
        switch(type){
            case "video":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_VideoIcon, {});
            case "write":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_TextIcon, {});
            case "sound":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_AudioIcon, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledResponseIcon, {
        $type: type,
        children: icon()
    });
}
var StyledResponseIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-10a6d6f8-0"
})(_templateObject1(), function(p) {
    return p.theme.colors.highlight;
}, function(p) {
    return p.$type === "video" && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
/* harmony default export */ var responses_ResponseIcon = (ResponseIcon);

// EXTERNAL MODULE: ./components/Image.tsx
var Image = __webpack_require__(7753);
;// CONCATENATED MODULE: ./components/responses/ResponseImage.tsx


function ResponseImage(param) {
    var image = param.image;
    if (!(image === null || image === void 0 ? void 0 : image.objectKey)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: null,
        objectKey: "responses-private/".concat(image.objectKey),
        alt: "",
        layout: "fill",
        objectFit: "cover"
    });
}
/* harmony default export */ var responses_ResponseImage = (ResponseImage);

;// CONCATENATED MODULE: ./components/responses/ResponseItem.tsx




function ResponseItem(param) {
    var response = param.response;
    var ref, ref1, ref2, ref3;
    var primaryContentType = function() {
        if (response.audio_object) {
            return "sound";
        }
        if (response.writing) {
            return "write";
        }
        if (response.image_object) {
            return "photo";
        }
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.ZP, {
        href: "/lets-share/".concat(response.id),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(responses_ResponseImage, {
                image: {
                    objectKey: response.image_object,
                    width: (ref = response.file_data) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.width,
                    height: (ref2 = response.file_data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.height
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(responses_ResponseIcon, {
                type: primaryContentType
            })
        ]
    });
}
/* harmony default export */ var responses_ResponseItem = (ResponseItem);


/***/ }),

/***/ 1548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r8": function() { return /* binding */ useCreativeResponsesQuery; },
  "lP": function() { return /* binding */ useGiftForChatUserQuery; },
  "RA": function() { return /* binding */ usePublicCreativeResponsesQuery; },
  "o": function() { return /* binding */ useResponsesFiltersQuery; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(7283);
// EXTERNAL MODULE: ./graphql/apolloWithAuth.ts
var apolloWithAuth = __webpack_require__(2756);
;// CONCATENATED MODULE: ./graphql/queries/creativeResponses.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CreativeResponsesQuery( $where: responses_bool_exp! ) {\n    creativeResponses: responses(\n      where: $where\n      order_by: { created_at: desc }\n    ) {\n      id\n      name\n      sharing\n      user_id\n      image_object\n      audio_object\n      file_data\n      age\n      country\n      created_at\n      approved_at\n      language\n      user {\n        id\n        email\n      }\n      activity {\n        ...on activities_default_Entry {\n          id: canonicalId,\n          slug\n          title\n          activityType {\n            ...on activityTypes_Category {\n              id\n              title\n              slug\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CREATIVE_REPONSES_QUERY = (0,lib/* gql */.Ps)(_templateObject());
/* harmony default export */ var queries_creativeResponses = (CREATIVE_REPONSES_QUERY);

;// CONCATENATED MODULE: ./graphql/queries/publicCreativeResponses.ts

function publicCreativeResponses_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PublicCreativeResponsesQuery(\n    $limit: Int\n    $offset: Int\n    $where: responses_bool_exp\n  ) {\n    creativeResponses: responses(\n      where: $where\n      order_by: { approved_at: desc }\n      limit: $limit\n      offset: $offset\n    ) {\n      id\n      writing\n      image_object\n      audio_object\n      file_data\n      age\n      country\n      created_at\n      approved_at\n      language\n      activity {\n        ...on activities_default_Entry {\n          id: canonicalId,\n          slug\n          title\n          activityType {\n            ...on activityTypes_Category {\n              id\n              title\n              slug\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    publicCreativeResponses_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PUBLIC_CREATIVE_REPONSES_QUERY = (0,lib/* gql */.Ps)(publicCreativeResponses_templateObject());
/* harmony default export */ var publicCreativeResponses = (PUBLIC_CREATIVE_REPONSES_QUERY);

;// CONCATENATED MODULE: ./graphql/queries/giftForChatUser.ts

function giftForChatUser_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GiftedCreativeResponseQuery(\n    $avoidType: String, \n    $language: String\n  ) {\n    creativeResponses: random_response(\n      args: { \n        avoid_type: $avoidType\n        language: $language\n      }\n    ) {\n      id\n      image_object\n      audio_object\n      file_data\n      age\n      country\n      created_at\n      approved_at\n      language\n      activity {\n        ...on activities_default_Entry {\n          id: canonicalId,\n          slug\n          title\n          activityType {\n            ...on activityTypes_Category {\n              id\n              title\n              slug\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    giftForChatUser_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var GIFT_FOR_CHAT_USER_QUERY = (0,lib/* gql */.Ps)(giftForChatUser_templateObject());
/* harmony default export */ var giftForChatUser = (GIFT_FOR_CHAT_USER_QUERY);

;// CONCATENATED MODULE: ./graphql/creativeResponses.ts



function creativeResponses_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n    query ResponseFiltersQuery(\n      $siteHandle: String!\n    ) {\n      responses(\n        distinct_on: activity_slug\n        where: {\n          sharing: {\n            _contains: "share-on-website"\n          }\n          approved_at: {\n            _is_null: false\n          }\n        }\n      ) {\n        activity(\n          site: [$siteHandle]\n        ) {\n          ...on activities_default_Entry {\n            id\n            slug\n            title\n            activityType {\n              id\n              slug\n              title\n            }\n          }\n        }\n      }\n    }\n  '
    ]);
    creativeResponses_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ResponseCountryCodesQuery {\n      responses(distinct_on: country) {\n        country\n      }\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ResponseAgesQuery {\n      responses(distinct_on: age) {\n        age\n      }\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var useCreativeResponsesQuery = function(param) {
    var _userId = param.userId, userId = _userId === void 0 ? null : _userId, _approved = param.approved, approved = _approved === void 0 ? null : _approved;
    var ref;
    var where = {};
    if (userId) {
        where.user_id = {
            _eq: userId
        };
    }
    if (approved === true) {
        where.approved_at = {
            _is_null: false
        };
    }
    if (approved === false) {
        where.approved_at = {
            _is_null: true
        };
    }
    var result = (0,apolloWithAuth/* useQuery */.aM)(queries_creativeResponses, {
        variables: {
            where: where
        }
    });
    var creativeResponses = (result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.creativeResponses) || [];
    return (0,_object_spread/* default */.Z)({
        creativeResponses: creativeResponses
    }, result);
};
var usePublicCreativeResponsesQuery = function(param) {
    var _limit = param.limit, limit = _limit === void 0 ? 30 : _limit, _offset = param.offset, offset = _offset === void 0 ? null : _offset, _activity = param.activity, activity = _activity === void 0 ? null : _activity, _country = param.country, country = _country === void 0 ? null : _country, _age = param.age, age = _age === void 0 ? null : _age, _artform = param.artform, artform = _artform === void 0 ? null : _artform;
    var ref;
    var where = {
        sharing: {
            _contains: "share-on-website"
        },
        approved_at: {
            _is_null: false
        }
    };
    if (activity) {
        where.activity_slug = {
            _eq: activity
        };
    }
    if (country) {
        where.country = {
            _eq: country
        };
    }
    if (age) {
        where.age = {
            _eq: age
        };
    }
    if (artform === "write") {
        where.writing = {
            _neq: ""
        };
    } else if (artform === "image") {
        where.image_object = {
            _is_null: false
        };
    } else if (artform === "sound") {
        where.audio_object = {
            _is_null: false
        };
    }
    var result = (0,apolloWithAuth/* useAnonymousQuery */.KI)(publicCreativeResponses, {
        variables: {
            limit: limit,
            offset: offset,
            where: where
        }
    });
    var creativeResponses = (result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.creativeResponses) || [];
    return (0,_object_spread/* default */.Z)({
        creativeResponses: creativeResponses
    }, result);
};
var useGiftForChatUserQuery = function(param) {
    var _language = param.language, language = _language === void 0 ? null : _language, _avoidType = param.avoidType, avoidType = _avoidType === void 0 ? null : _avoidType, _skip = param.skip, skip = _skip === void 0 ? false : _skip;
    var ref;
    var result = (0,apolloWithAuth/* useAnonymousQuery */.KI)(giftForChatUser, {
        variables: {
            avoidType: avoidType,
            language: language
        },
        skip: skip
    });
    var creativeResponse = (result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.creativeResponses[0]) || null;
    return (0,_object_spread/* default */.Z)({
        creativeResponse: creativeResponse
    }, result);
};
var useResponsesFiltersQuery = function(locale) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var activitiesResult = (0,apolloWithAuth/* useAnonymousQuery */.KI)((0,lib/* gql */.Ps)(creativeResponses_templateObject()), {}, locale);
    var activities = (activitiesResult === null || activitiesResult === void 0 ? void 0 : (ref = activitiesResult.data) === null || ref === void 0 ? void 0 : (ref1 = ref.responses) === null || ref1 === void 0 ? void 0 : ref1.length) ? activitiesResult.data.responses.map(function(r) {
        return r.activity[0];
    }) : [];
    var artforms = (activities === null || activities === void 0 ? void 0 : activities.length) ? activities.reduce(function(collected, activity) {
        return (0,_to_consumable_array/* default */.Z)(collected).concat((0,_to_consumable_array/* default */.Z)(activity.activityType.map(function(activityType) {
            if (!collected.find(function(at) {
                return at.value === activityType.slug;
            })) {
                return {
                    title: activityType.title,
                    value: activityType.slug
                };
            }
            return null;
        }).filter(function(activityType) {
            return !!activityType;
        })));
    }, []) : [];
    var countryCodesResult = (0,apolloWithAuth/* useAnonymousQuery */.KI)((0,lib/* gql */.Ps)(_templateObject1()));
    var countryCodes = (countryCodesResult === null || countryCodesResult === void 0 ? void 0 : (ref2 = countryCodesResult.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.responses) === null || ref3 === void 0 ? void 0 : ref3.length) ? countryCodesResult.data.responses.filter(function(r) {
        return !!r.country;
    }).map(function(r) {
        return {
            title: r.country,
            value: r.country
        };
    }) : [];
    var agesResult = (0,apolloWithAuth/* useAnonymousQuery */.KI)((0,lib/* gql */.Ps)(_templateObject2()));
    var ages = (agesResult === null || agesResult === void 0 ? void 0 : (ref4 = agesResult.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.responses) === null || ref5 === void 0 ? void 0 : ref5.length) ? agesResult.data.responses.map(function(r) {
        return {
            title: r.age,
            value: r.age
        };
    }) : [];
    return {
        activities: activities,
        countryCodes: countryCodes,
        ages: ages,
        artforms: artforms
    };
};


/***/ }),

/***/ 3770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ lets_explore; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./components/layout/Stack.tsx
var Stack = __webpack_require__(4970);
// EXTERNAL MODULE: ./components/layout/Background.tsx
var Background = __webpack_require__(7940);
// EXTERNAL MODULE: ./components/AppChrome.tsx + 7 modules
var AppChrome = __webpack_require__(7504);
// EXTERNAL MODULE: ./components/Hero.tsx
var Hero = __webpack_require__(8634);
// EXTERNAL MODULE: ./components/ContentBuilder.tsx
var ContentBuilder = __webpack_require__(8375);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./graphql/creativeResponses.ts + 3 modules
var creativeResponses = __webpack_require__(1548);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(6797);
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(570);
// EXTERNAL MODULE: ./styles/textLink.ts
var textLink = __webpack_require__(308);
;// CONCATENATED MODULE: ./components/SectionIntro.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  margin-left: var( --grid-parent-gutter );\n  margin-right: var( --grid-parent-gutter );\n\n  > * {\n    margin: 0;\n    margin-left: var( --grid-child-gutter );\n    margin-right: var( --grid-child-gutter );\n  }\n\n  @media ( min-width: 800px ) {\n    grid-template-columns: calc( ( 2 / 10 ) * 100% ) calc( ( 8 / 10 ) * 100% );\n\n    > *.hod-grid-2-3 {\n      grid-column: 2 / 3;\n    }\n  }\n  \n  @media ( min-width: 1000px ) {\n    grid-template-columns: calc( ( 2 / 10 ) * 100% ) calc( ( 7 / 10 ) * 100% );\n  }\n\n  @media ( min-width: 1250px ) {\n    grid-template-columns: calc( ( 2 / 10 ) * 100% ) calc( ( 6 / 10 ) * 100% );\n  }\n\n  h2 {\n    ",
        "\n    font-size: ",
        ";\n  }\n\n  p {\n    margin: 1rem 0;\n\n    &:first-child {\n      margin-top: 0;\n    }\n    \n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  a {\n    color: inherit;\n    text-decoration-color: ",
        ";\n  }\n\n  > a,\n  p a:only-child {\n    ",
        "\n  }\n\n  ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 1rem 0;\n\n  &:first-child {\n    margin-top: 0;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  > a {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SectionIntro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6830f13b-0"
})(_templateObject(), function(p) {
    return p.theme.typo.neueHaasBold;
}, function(p) {
    return p.theme.typo.sizes.medium;
}, function(p) {
    return p.theme.colors.highlight;
}, textLink/* soloTextLink */.RY, Button/* default */.Z, function(p) {
    return p.theme.typo.sizes.dropped;
});
var SectionIntroHTML = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6830f13b-1"
})(_templateObject1(), textLink/* soloTextLink */.RY);
/* harmony default export */ var components_SectionIntro = (SectionIntro);

// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(5741);
// EXTERNAL MODULE: ./components/responses/ResponseItem.tsx + 5 modules
var ResponseItem = __webpack_require__(8834);
;// CONCATENATED MODULE: ./components/LetsShare.tsx

function LetsShare_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow-x: hidden;\n\n  > div {\n    position: relative;\n    display: grid;\n    grid-template-columns: repeat( 7, 1fr );\n    width: calc( ",
        "% + ( var( --grid-gutter ) * ",
        " ) );\n    left: calc( ( ( -100% / 3 ) - ( var( --grid-gutter ) / 3 ) ) * 2 );\n    margin: 0 var( --grid-parent-gutter );\n\n    > * {\n      position: relative;\n      margin: var( --grid-child-gutter );\n\n      a {\n        position: relative;\n        display: block;\n        width: 100%;\n        padding-bottom: 100%;\n        background: ",
        ";\n      }\n    }\n  }\n"
    ]);
    LetsShare_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










function LetsShare(param) {
    var title = param.title, description = param.description;
    var ref = (0,creativeResponses/* usePublicCreativeResponsesQuery */.RA)({
        limit: 7
    }), responses = ref.creativeResponses;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.ZP, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ShiftAlign */.Ow, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_SectionIntro, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionIntroHTML, {
                                    dangerouslySetInnerHTML: {
                                        __html: description
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    $inline: true,
                                    $outline: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                        href: "/lets-share",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            description: "Button: View all creative responses",
                                            defaultMessage: "View all creative responses",
                                            id: "pS8k6Q"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                $top: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLetsShareGrid, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: responses.map(function(response) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponseItem/* default */.Z, {
                                    response: response
                                })
                            }, response.id);
                        })
                    })
                })
            })
        ]
    });
}
var StyledLetsShareGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a2ba7d58-0"
})(LetsShare_templateObject(), 7 / 3 * 100, 7 / 3, function(p) {
    return p.theme.colors.highlight;
});
/* harmony default export */ var components_LetsShare = (LetsShare);

// EXTERNAL MODULE: ./components/activities/Activities.tsx + 1 modules
var Activities = __webpack_require__(5159);
;// CONCATENATED MODULE: ./components/LetsMake.tsx








function LetsMake(param) {
    var title = param.title, description = param.description, activities = param.activities;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.ZP, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ShiftAlign */.Ow, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_SectionIntro, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionIntroHTML, {
                                    dangerouslySetInnerHTML: {
                                        __html: description
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    $inline: true,
                                    $outline: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                        href: "/lets-make",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            description: "Button: View all creative responses",
                                            defaultMessage: "View all creative activities",
                                            id: "Y3NRa/"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                $top: 2,
                $bottom: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Activities/* default */.Z, {
                    activities: activities.slice(0, 3)
                })
            })
        ]
    });
}
/* harmony default export */ var components_LetsMake = (LetsMake);

// EXTERNAL MODULE: ./components/LetsDiscusCTABlock.tsx + 1 modules
var LetsDiscusCTABlock = __webpack_require__(6753);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/icons/PlusIcon.tsx
var PlusIcon = __webpack_require__(3362);
;// CONCATENATED MODULE: ./components/Faqs.tsx

function Faqs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 2rem;\n"
    ]);
    Faqs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Faqs_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          transform: rotate( 45deg );\n        "
    ]);
    Faqs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: auto;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n\n  button {\n    width: 100%;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    margin-left: auto;\n    cursor: pointer;\n\n    > h3 {\n      display: flex;\n      margin-bottom: 1rem;\n      text-align: left;\n      transition: color .3s ease-out;\n\n      span {\n        display: block;\n        margin-left: auto;\n        padding-left: 2rem;\n      }\n\n      svg {\n        transform-origin: 50% 50%;\n        transition: transform .3s ease-out;\n\n        ",
        "\n      }\n    }\n\n    &:hover {\n      > h3 {\n        color: ",
        ";\n      }\n    }\n  }\n\n  > div {\n    overflow: hidden;\n    height: 0;\n\n    > *:last-child {\n      margin-bottom: 1rem;\n    }\n\n    ",
        "\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






function Faqs(param) {
    var faqs = param.faqs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ShiftAlign */.Ow, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_SectionIntro, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: faqs.sectionTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: faqs.introCopy
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuestions, {
                        className: "hod-grid-2-3",
                        children: faqs.faqs.map(function(faq) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordianItem, {
                                title: faq.question,
                                body: faq.answer
                            }, faq.id);
                        })
                    })
                ]
            })
        })
    });
}
function AccordianItem(param) {
    var title = param.title, body = param.body, _initiallyOpen = param.initiallyOpen, initiallyOpen = _initiallyOpen === void 0 ? false : _initiallyOpen;
    var ref = (0,react.useState)(initiallyOpen), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAccordianItem, {
        $isOpen: isOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: function() {
                    return setIsOpen(function(s) {
                        return !s;
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    children: [
                        title,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon/* default */.Z, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: body
                }
            })
        ]
    });
}
var StyledQuestions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-595f45f0-0"
})(Faqs_templateObject());
var StyledAccordianItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-595f45f0-1"
})(_templateObject3(), function(p) {
    return p.theme.colors.grey1;
}, function(p) {
    return p.$isOpen && (0,styled_components_browser_esm/* css */.iv)(Faqs_templateObject1());
}, function(p) {
    return p.theme.colors.highlight;
}, function(p) {
    return p.$isOpen && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
});
/* harmony default export */ var components_Faqs = (Faqs);

// EXTERNAL MODULE: ./components/MetaTags.tsx
var MetaTags = __webpack_require__(8716);
;// CONCATENATED MODULE: ./pages/lets-explore.tsx












function LetsExplorePage(param) {
    var letsExplore = param.entry, letsMake = param.letsMake, letsShare = param.letsShare, activities = param.activities;
    var formatMessage = (0,useIntl/* default */.Z)().formatMessage;
    var heroContent = letsExplore.hero[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppChrome/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                url: "/lets-explore",
                title: formatMessage({
                    description: "Let\u2019s Explore",
                    defaultMessage: "Let\u2019s Explore",
                    id: "n4jYlJ"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Background/* default */.Z, {
                $color: "grey9",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                        title: heroContent.heroTitle,
                        subheading: heroContent.subtitle,
                        html: heroContent.body,
                        bottomPad: "small"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        $bottom: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuilder/* default */.Z, {
                            content: letsExplore.contentBuilder
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        $top: 3,
                        $bottom: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LetsShare, {
                            title: letsShare.title,
                            description: letsShare.description
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        $top: 3,
                        $bottom: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LetsMake, {
                            title: letsMake.title,
                            description: letsMake.description,
                            activities: activities
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        $top: 3,
                        $bottom: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Faqs, {
                            faqs: letsExplore.faqs[0]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LetsDiscusCTABlock/* default */.Z, {})
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var lets_explore = (LetsExplorePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [184,182,121,194,774,888,179], function() { return __webpack_exec__(4122); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);